/**
 * @generated SignedSource<<ac735105209c1629632fcbcaecc46e17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatePageRouteQuery$variables = {
  addressOrEnsName: string;
};
export type DelegatePageRouteQuery$data = {
  readonly delegate: {
    readonly statement: {
      readonly " $fragmentSpreads": FragmentRefs<"StatementSectionFragment" | "TopIssuesFragment" | "TopStakeholdersFragment">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PastVotesFragment" | "VoterPanelFragment">;
  };
};
export type DelegatePageRouteQuery = {
  response: DelegatePageRouteQuery$data;
  variables: DelegatePageRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "addressOrEnsName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "addressOrEnsName",
    "variableName": "addressOrEnsName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decimals",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ResolvedName",
      "kind": "LinkedField",
      "name": "resolvedName",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "choiceIdx",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegatePageRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VoterPanelFragment"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StatementSectionFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TopIssuesFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TopStakeholdersFragment"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PastVotesFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DelegatePageRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateMetrics",
            "kind": "LinkedField",
            "name": "delegateMetrics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenHoldersRepresentedCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "proposalsCreated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ofLastTenProps",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "againstVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ofTotalProps",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "tokensRepresentedVote",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bpsOfTotal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bpsOfStakedSupply",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TokenAmount",
                "kind": "LinkedField",
                "name": "amount",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discord",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TopIssue",
                "kind": "LinkedField",
                "name": "topIssues",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TopStakeholder",
                "kind": "LinkedField",
                "name": "topStakeholders",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "delegatingTo",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SnapshotVote",
            "kind": "LinkedField",
            "name": "snapshotVotes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SnapshotProposal",
                "kind": "LinkedField",
                "name": "proposal",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProposalChoice",
                    "kind": "LinkedField",
                    "name": "choices",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "votingPower",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "choice",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "selectedChoiceIdx",
                        "storageKey": null
                      }
                    ],
                    "type": "SnapshotVoteChoiceSingle",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WeightedSelectedChoice",
                        "kind": "LinkedField",
                        "name": "weights",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "SnapshotVoteChoiceWeighted",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "choices",
                        "storageKey": null
                      }
                    ],
                    "type": "SnapshotVoteChoiceRanked",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "approvedChoices",
                        "storageKey": null
                      }
                    ],
                    "type": "SnapshotVoteChoiceApproval",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WeightedSelectedChoice",
                        "kind": "LinkedField",
                        "name": "weights",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "SnapshotVoteChoiceQuadratic",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Vote",
            "kind": "LinkedField",
            "name": "votes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Transaction",
                "kind": "LinkedField",
                "name": "transaction",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Block",
                    "kind": "LinkedField",
                    "name": "block",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timestamp",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hash",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Proposal",
                "kind": "LinkedField",
                "name": "proposal",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalValue",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "number",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportDetailed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VotingPower",
                "kind": "LinkedField",
                "name": "votes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TokenAmount",
                    "kind": "LinkedField",
                    "name": "amount",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3560da5c7ed0c83139c74481b7cffe6b",
    "id": null,
    "metadata": {},
    "name": "DelegatePageRouteQuery",
    "operationKind": "query",
    "text": "query DelegatePageRouteQuery(\n  $addressOrEnsName: String!\n) {\n  delegate(addressOrEnsName: $addressOrEnsName) {\n    ...VoterPanelFragment\n    statement {\n      ...StatementSectionFragment\n      ...TopIssuesFragment\n      ...TopStakeholdersFragment\n    }\n    ...PastVotesFragment\n    id\n  }\n}\n\nfragment DelegateFromListRowFragment on DelegateMetrics {\n  tokenHoldersRepresentedCount\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n      ...ENSAvatarFragment\n    }\n  }\n  tokensRepresentedVote {\n    amount {\n      ...TokenAmountDisplayFragment\n    }\n  }\n}\n\nfragment DelegatingToRowFragment on Delegate {\n  delegatingTo {\n    address {\n      resolvedName {\n        address\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment ENSAvatarFragment on ResolvedName {\n  name\n}\n\nfragment ForAgainstAbstainRowFragment on Delegate {\n  delegateMetrics {\n    forVotes\n    againstVotes\n  }\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment PastVotesFragment on Delegate {\n  snapshotVotes {\n    id\n    createdAt\n    ...SnapshotVoteDetailsFragment\n  }\n  votes {\n    id\n    transaction {\n      block {\n        timestamp\n        id\n      }\n      id\n    }\n    proposal {\n      totalValue\n      id\n    }\n    ...VoteDetailsFragment\n  }\n}\n\nfragment ProposalsCreatedRowFragment on DelegateMetrics {\n  proposalsCreated\n}\n\nfragment ProposalsVotedRowFragment on Delegate {\n  delegateMetrics {\n    totalVotes\n    ofTotalProps\n  }\n}\n\nfragment RecentActivityRowFragment on DelegateMetrics {\n  ofLastTenProps\n}\n\nfragment SnapshotVoteDetailsFragment on SnapshotVote {\n  reason\n  createdAt\n  proposal {\n    title\n    link\n    choices {\n      title\n    }\n    id\n  }\n  ...SnapshotVoteDetailsVoteChoiceFragment\n}\n\nfragment SnapshotVoteDetailsVoteChoiceFragment on SnapshotVote {\n  votingPower\n  choice {\n    __typename\n    ... on SnapshotVoteChoiceSingle {\n      selectedChoiceIdx\n    }\n    ... on SnapshotVoteChoiceWeighted {\n      weights {\n        choiceIdx\n        weight\n      }\n    }\n    ... on SnapshotVoteChoiceRanked {\n      choices\n    }\n    ... on SnapshotVoteChoiceApproval {\n      approvedChoices\n    }\n    ... on SnapshotVoteChoiceQuadratic {\n      weights {\n        weight\n        choiceIdx\n      }\n    }\n  }\n  proposal {\n    choices {\n      title\n    }\n    id\n  }\n}\n\nfragment StatementSectionFragment on DelegateStatement {\n  statement\n}\n\nfragment TokenAmountDisplayFragment on TokenAmount {\n  amount\n  decimals\n  currency\n}\n\nfragment TopIssuesFragment on DelegateStatement {\n  topIssues {\n    type\n    value\n  }\n}\n\nfragment TopStakeholdersFragment on DelegateStatement {\n  topStakeholders {\n    type\n    value\n  }\n}\n\nfragment VoteDetailsFragment on Vote {\n  supportDetailed\n  votes {\n    amount {\n      amount\n      decimals\n    }\n  }\n  transaction {\n    block {\n      timestamp\n      id\n    }\n    hash\n    id\n  }\n  proposal {\n    number\n    totalValue\n    id\n  }\n}\n\nfragment VotePowerRowFragment on Delegate {\n  tokensRepresentedVote {\n    bpsOfTotal\n    bpsOfStakedSupply\n  }\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n\nfragment VoterPanelFragment on Delegate {\n  delegateMetrics {\n    ...DelegateFromListRowFragment\n    ...ProposalsCreatedRowFragment\n    ...RecentActivityRowFragment\n  }\n  ...ForAgainstAbstainRowFragment\n  ...VotePowerRowFragment\n  ...ProposalsVotedRowFragment\n  ...DelegateProfileImageFragment\n  ...VoterPanelActionsFragment\n  ...DelegatingToRowFragment\n}\n"
  }
};
})();

(node as any).hash = "936e8faa6efc96e66525b0e44fd1ba72";

export default node;
